var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLivecasino43A0(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4788",
    "data-name": "Group 4788",
    transform: "translate(22957 -688)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4362",
    "data-name": "Rectangle 4362",
    width: 24,
    height: 24,
    transform: "translate(-22957 688)",
    fill: "none",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4764",
    "data-name": "Group 4764",
    transform: "translate(-22954.229 689.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4765",
    "data-name": "Group 4765",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6694",
    "data-name": "Path 6694",
    d: "M9.23,0c16.318,8.9,7.152,19.765,1.581,15.6a2.617,2.617,0,0,0-3.163,0C2.077,19.766-7.089,8.9,9.23,0",
    transform: "translate(0)",
    fill: "rgba(244,65,65,0.4)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6695",
    "data-name": "Path 6695",
    d: "M18.471,36.043c0-2.037-2.073-3.688-4.631-3.688s-4.631,1.651-4.631,3.688Z",
    transform: "translate(-4.61 -16.198)",
    fill: "#f44141"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivecasino43A0);
export default __webpack_public_path__ + "static/media/livecasino43a0.6405d54d4a1563b88b471ae333f9039c.svg";
export { ForwardRef as ReactComponent };